import {
  initialState,
  Actions,
  State,
  UPDATE_WHITE_LABEL,
  UPDATE_WHITE_LABEL_SUCCESS,
  UPDATE_WHITE_LABEL_ERROR,
  RESET_UPDATE_WHITE_LABEL,
} from '../../types/user/white-label'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case UPDATE_WHITE_LABEL:
      return {
        ...state,
        states: {
          success: false,
          loading: true,
          error: false,
        }
      };
    case UPDATE_WHITE_LABEL_SUCCESS:
      return {
        ...state,
        states: {
          success: true,
          loading: false,
          error: false,
        },
      };
    case UPDATE_WHITE_LABEL_ERROR:
      return {
        ...state,
        states: {
          success: false,
          loading: false,
          error: action.payload,
        },
      };
    case RESET_UPDATE_WHITE_LABEL:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
